import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'serviceMonitor';

const serviceMonitorService = {
  getTasks: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  startJob: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/startjob`,
      data,
    });
  },

  stopJob: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/stopjob`,
      data,
    });
  },

  interruptJob: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/interruptjob`,
      data,
    });
  },
};
export default serviceMonitorService;
